import { IEntity, ITypeEntity } from '@pf/shared-common';
import {
    EquipmentTypeSearchRequestParams,
    EquipmentTypeViewModelCreateBody,
    EquipmentTypeViewModelRead,
    ResourceAuth,
    WarehouseEquipmentCategory,
    WarehouseFragment,
} from '@control-tower/platform-wms';
import { ICustomFieldDto } from '@pf/shared/util-platform';
import { IWarehouseEntity } from '../interfaces/warehouse-entity';

export type EquipmentTypeRead = EquipmentTypeViewModelRead & IEntity;
export type EquipmentTypeCreate = EquipmentTypeViewModelCreateBody;
export type EquipmentTypeSearchParams = EquipmentTypeSearchRequestParams;

export class EquipmentTypeDto implements ITypeEntity, IWarehouseEntity {
    constructor(data: Partial<EquipmentTypeDto>) {
        Object.assign(this, data);
    }

    id!: string;
    warehouse!: WarehouseFragment;
    category!: WarehouseEquipmentCategory;
    name!: string;

    isDeleted?: boolean;
    createdDate?: string;
    modifiedDate?: string;

    code?: string;
    description?: string | null;
    isScannable?: boolean;
    requiresAuthorization?: boolean;
    resourceAuth?: ResourceAuth;
    customFields?: Array<ICustomFieldDto> | null;
}
